import { gql } from '@apollo/client';

import { CustodianProfileBaseFields } from './custodianProfile.fragment';

export * from './custodianProfile.query.generated';

export const CUSTODIAN_PROFILE = gql`
  ${CustodianProfileBaseFields}
  query custodianProfile($id: ID!) {
    custodianProfile(custodianProfileId: $id) {
      ...CustodianProfileBaseFields
      custodianAssets {
        id
        name
        operationalStatus
        externalId
        custodianStatus
        custodianIntegration {
          id
          integration {
            id
            provider
            accountName
          }
        }
        updatedAt
      }
      custodianIntegrations {
        id
        status
        updatedAt
        integration {
          id
          provider
          accountName
        }
        custodianAssets {
          id
          name
          operationalStatus
          externalId
          custodianStatus
        }
      }
      custodianOperations {
        id
        custodianServiceEvents
        custodianServiceEventsCustom
        dataRetention
        endOfRetentionPeriod
        endOfRetentionPeriodCustom
        operationType
        operationTypeCustom
        regulatoryRequirements
        regulatoryRequirementsCustom
      }
      policy {
        activate
        remove
        requestTermination
        submitForReview
        update
      }
      creator {
        id
        name
      }
    }
  }
`;
